module.exports = __webpack_public_path__ + "static/media/Stellar Max Single Headboard - 120 cm_Black.c39d4f64.png";